import type { Routes } from '@angular/router';

export const CAMPAIGNS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/campaigns/views/campaigns/campaigns.component').then((m) => m.CampaignsComponent),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'list',
            },
            {
                path: 'list',
                loadComponent: () =>
                    import('#modules/campaigns/views/campaigns/components/campaigns-list/campaigns-list.component').then(
                        (m) => m.CampaignsListComponent
                    ),
            },
        ],
    },
];
